import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';

export default function AppFooter() {
    return (
        <Box sx={{ flexGrow: 1, backgroundColor: '#bfbfbf', overflow: 'hidden' }}>         
            <Grid container padding={2} spacing={{ xs: 2, md: 3 }} sx={{backgroundColor: '#747474'}}>
                <Grid item xs={12} sm={12} md={12}>
                    <Typography textAlign={'center'}>Copyright 2022 | Tier 1 Asset Warranty</Typography>                    
                </Grid>
            </Grid>
        </Box >
    );
}